import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';
import SearchEventItemImpl from './search-event-item.js';

const { UIView } = MojitoCore.Presentation;

/**
 * A single event card inside the search discovery overlay. Clicking the card navigates to the event,
 * while the selections below it can be added to the betslip directly.
 *
 * @class SearchEventItem
 * @memberof Mojito.Applications.Sports.Search
 */

/**
 * `SearchEventItem` prop types.
 *
 * @property {object} event - Event to render.
 * @property {object} [market = {}] - Market whose selections are shown on the card.
 * @property {boolean} [isSearchResult = false] - Flag indicating that the event comes from a search result, which is reported to analytics.
 * @property {Function} [onNavigate] - Called after the user triggers navigation to the event.
 *
 * @memberof Mojito.Applications.Sports.Search.SearchEventItem
 */
const propTypes = {
    event: PropTypes.object.isRequired,
    market: PropTypes.object,
    isSearchResult: PropTypes.bool,
    onNavigate: PropTypes.func,
};

const defaultProps = {
    market: {},
    isSearchResult: false,
    onNavigate: noop,
};

export default UIView('SearchEventItem', SearchEventItemImpl, propTypes, defaultProps);
